import { DeferredPromise, pDefer } from '@naturalcycles/js-lib/promise'
import { createContext } from 'react'

export type ConfirmInput =
  | {
      message: string
      title?: string
      proceedText?: string
      abortText?: string
    }
  | string

export const ConfirmContext = createContext<
  (input: ConfirmInput) => DeferredPromise<boolean>
>(() => pDefer<boolean>())
